import React, { Component } from 'react';
import { Button, Row, Container, Col, Modal, ModalHeader, ModalFooter, ModalBody, FormGroup } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import axios from 'axios';
import { CONFIG } from '../../../../Utils/config';
import { normalizeInput } from '../../../../Utils/utils';
import { Link } from "react-router-dom";
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './Seller.css';
import delete_icon from '../../../../Assets/Img/delete.png';
import restore_icon from '../../../../Assets/Img/restore-icon.png';
import view_icon from '../../../../Assets/Img/view.png';
import transitions from '@material-ui/core/styles/transitions';
import { Pagination } from '../../../Shared/Pagination';
import { CreateUser } from '../../Components/Shared/CreateUser';

const actionsStyles = theme => ({
  tablepaggination: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing * 2.5,
  },
});


const SellerTableWrapped = withStyles(actionsStyles, { withTheme: true })(
  Pagination,
);

export default class Seller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addModal: false,
      userDetail: [],
      pageCount: 0,
      userList: [],
      userType: 3,
      positionList: [],
      positionId: 0,
      stateList: [],
      stateId: 0,
      position: '',
      showPosition: false,
      statusList: [
        {
          "id": -1,
          "name": "All"
        },
        {
          "id": 2,
          "name": "Approved"
        },
        {
          "id": 3,
          "name": "Rejected"
        }
      ],
      phone: ''
    }
    this.viewSeller = this.viewSeller.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
  }

  handlePhoneChange({ target: { value } }) {
    this.setState(prevState => ({ phone: normalizeInput(value, prevState.phone) }));
  };

  addtoggleModal() {
    this.setState(state => ({ addModal: !state.addModal }))
  }

  toggleClose = () => this.setState(state => ({ addModal: false }))

  handleChange(e) {

    if (e.target.name === 'positionId') {
      var position = '';
      var showPosition = e.target.value === "5" ? true : false;
      this.setState({ [e.target.name]: e.target.value, position, showPosition });
    }
    else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  stateChange(e) {

    var value = e.target.value;
    this.setState({ stateId: value })
  }

  getDetails(params) {
    if (params == null) {
      params = this.state.userList.Criteria;
    }
    let token = localStorage.getItem('accessKey');
    this.setState({ isLoading: true });

    if (token) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
    }

    axios.post(CONFIG.API_URL + 'admin/users', params)
      .then(res => {
        let users = res.data;
        this.setState({ userList: users, isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      })
  }

  deleteSeller(id, sellerId) {
    let token = localStorage.getItem('accessKey');
    if (token) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
    }
    axios.post(CONFIG.API_URL + 'admin/user/status/' + id + '/' + sellerId)
      .then(res => {
        this.getDetails(null);
      })
      .catch((err) => {
        console.log(err);
      })
  }

  deleteUser(id) {
    confirmAlert({
      title: 'Delete User',
      message: 'Are you sure want to delete this user?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let token = localStorage.getItem('accessKey');
            if (token) {
              axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
            }
            this.setState({ isLoading: true });
            axios.delete(CONFIG.API_URL + 'admin/user/' + id)
              .then(res => {
                this.getDetails(null);
                this.setState({ isLoading: false });
              })
              .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  restoreUser(id) {

    confirmAlert({
      title: 'Delete User',
      message: 'Are you sure want to restore this user?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let token = localStorage.getItem('accessKey');
            if (token) {
              axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
            }
            this.setState({ isLoading: true });
            axios.request({
              url: CONFIG.API_URL + 'admin/user/' + id,
              method: 'put',
            })
              .then(res => {
                this.getDetails(null);
                this.setState({ isLoading: false });
              })
              .catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  viewSeller(sellerId) {
    const { from } = { from: { pathname: '/viewseller/' + sellerId } };
    this.props.params.history.push(from);
  }

  search(event, errors, values) {
    const params = {
      'Name': values.Name,
      'Status': values.Status == '' ? -1 : values.Status,
      'UserType': this.state.userType,
      'PageLength': CONFIG.PAGE_LENGTH,
      'Page': 1
    }

    this.setState({ pageCount: 0 });
    this.getDetails(params);
  }

  componentDidMount() {
    const params = {
      'Name': '',
      'Status': -1,
      'UserType': this.state.userType,
      'PageLength': CONFIG.PAGE_LENGTH,
      'Page': 1
    }
    this.setState({ pageCount: 0 });
    this.getDetails(params);
  }

  resetSearch() {
    this.myFormSearch && this.myFormSearch.reset();
    const params = {
      'Name': '',
      'Status': "-1",
      'UserType': this.state.userType,
      'PageLength': CONFIG.PAGE_LENGTH,
      'Page': 1
    }
    this.setState({ pageCount: 0 });

    this.getDetails(params);
  }

  handleChangePageTrack = (event, pageCount) => {
    this.setState({ pageCount });
    this.state.userList.Criteria.Page = pageCount + 1;
    this.getDetails(null);
  };

  handleChangeRowsPerPageTrack = event => {
    this.setState({ pageCount: 0, 10: event.target.value });
  };

  render() {
    document.title = CONFIG.PAGE_TITLE + 'User Management - Seller Search';
    const { isLoading, pageCount, userList, statusList, stateList, positionList, positionId, addModal, showPosition, position } = this.state;
    return (
      <main className="dashboard-layout-height">
        {isLoading ? <div className="loader-wrap"><div className="page-loading"></div></div> : ''}
        {addModal ? <CreateUser isOpen={addModal} parentMethod={this.getDetails.bind(this, null)} /> : ''}
        <div className="admin-dash-details">
          <AvForm onSubmit={this.search.bind(this)} ref={c => (this.myFormSearch = c)} className="form-back-shadow">
            <Row>
              <Col md={4}>
                <AvField name="Name" label="Name:" />
              </Col>
              <Col md={4}>
                <AvField type="select" name="Status" label="Status:" helpMessage="" value="-1">
                  {statusList ? statusList.map((c) =>
                    <option value={c.id}>{c.name}</option>
                  ) : ''}
                </AvField>
              </Col>
              <Col md={4} className="btn-search">
                <Button id="btn" color="primary" className="search-butn">Search</Button>
                <Button onClick={this.resetSearch.bind(this)} className="btn-reset">Reset</Button>
              </Col>
            </Row>
          </AvForm>
          <Row className="padding-col">
            <Col md={6} className="total-numb">
              {userList.Users && userList.Users.length > 0 ? <p>Total Sellers: {userList.Pagination.TotalRecords}</p> : ''}
            </Col>
            <Col md={6} className="add-new-btn">
              <Link onClick={this.addtoggleModal.bind(this)}>[+] Add New Seller</Link>
            </Col>
          </Row>
          <div className="table-model">
            {userList.Users && userList.Users.length > 0 ?
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Seller</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userList.Users ? userList.Users.map((seller) =>
                    <TableRow key={seller.ID}>
                      <TableCell>{moment(seller.CreatedDate).format("L")}</TableCell>
                      <TableCell>{seller.FirstName} {seller.LastName}</TableCell>
                      <TableCell>{seller.PhoneNumber}</TableCell>
                      <TableCell>{seller.Email}</TableCell>
                      <TableCell>
                        <Button type="view" className="button-common background-view" onClick={this.viewSeller.bind(this, seller.ID)}>View</Button>
                        {seller.StatusID == 2 ?
                          <Button type="delete" className="button-common background-delete" onClick={this.deleteUser.bind(this, seller.ID)}>Delete</Button> : seller.StatusID == 3 ?
                            <Button type="restore" className="button-common" onClick={this.restoreUser.bind(this, seller.ID)}>Restore</Button> : ''
                        }
                      </TableCell>
                    </TableRow>
                  ) :
                    <TableRow></TableRow>
                  }
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[1]}
                      colSpan={5}
                      count={userList.Users ? userList.Pagination.TotalRecords : 0}
                      rowsPerPage={CONFIG.PAGE_LENGTH}
                      page={pageCount}
                      SelectProps={{
                        native: true,
                      }}
                      onChangePage={this.handleChangePageTrack}
                      onChangeRowsPerPage={this.handleChangeRowsPerPageTrack}
                      ActionsComponent={SellerTableWrapped}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
              : <h6 className="no-records-found">No records found</h6>}
          </div>
        </div>
      </main>
    );
  }
}
